import { CheckCircleIcon } from 'lucide-react'

interface PaymentSummaryBarProps {
  totalAmount: number
  outstandingAmount: number
}

export const PaymentSummaryBar = ({ totalAmount, outstandingAmount }: PaymentSummaryBarProps) => {
  const isPaid = outstandingAmount <= 0
  return (
    <div className="flex items-center gap-4 text-xs font-semibold bg-muted/30 px-3 py-1.5 rounded-lg border border-border/50">
      <div className="flex items-center gap-1.5 text-muted-foreground">
        <span>Total:</span>
        <span className="text-foreground">${totalAmount.toLocaleString('es-AR')}</span>
      </div>
      <div className="flex items-center gap-1.5 text-muted-foreground border-l pl-4">
        {isPaid ? (
          <div className="flex items-center gap-1.5 text-green-500 font-bold">
            <CheckCircleIcon className="h-3.5 w-3.5" />
            <span>Pagado</span>
          </div>
        ) : (
          <>
            <span>Pendiente:</span>
            <span className="font-bold text-red-500">
              ${outstandingAmount.toLocaleString('es-AR')}
            </span>
          </>
        )}
      </div>
    </div>
  )
}
